
    import I18n from 'i18nObj';
    
      import 'translations/module_sequence_footer';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('module_sequence_footer');
  